import React from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as StatusDotGreen } from 'assets/images/icons/dots/statusdot-green.svg';
import { IconProps } from 'types/icon';

const StatusDotGreenIcon: React.FC<IconProps> = ({
    width = '18px',
    height = '18px',
}) => {
    return (
        <SvgIcon
            component={StatusDotGreen}
            inheritViewBox
            style={{ width, height }}
        />
    );
};

export default StatusDotGreenIcon;
